export const Logo = () =>{
    return(
        <p className='logo-style'>
            Starfish
        </p>
        // <img/>
    )
}